import React, { useEffect } from 'react';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { DonutChart, SemiDonutChart } from '../../../shared';
import { VIRTUAL_CHART_OPTIONS,
    IN_PERSON_CHART_OPTIONS,
    SEMI_DONUT_CHART_OPTIONS,
    SEMI_DONUT_CHART_SERIES } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getPeerPeerAffinityData } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

export default function Channels() {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { peerToPeer } = useSelector(state => state.physicianTargetListAnalysis);
    const {
        virtualChannel, inPersonChannel, isLoading, peerToPeerChannel 
    } = peerToPeer;
    useEffect(() => {
        if(company.id){
            dispatch(getPeerPeerAffinityData({ companyId: company.id }));
        }
        
    },[company.id]);
    return (
        <Box className="box-sizing-border-box">
            <Typography className="text-lg-semi-bold gray-900">
                Peer To Peer
            </Typography>
            <Box className="padding-tb-24-rl-0">
                <Grid container className="flex-row br-16px" spacing={'24px'}>
                    {/*  Virtual */}
                    <Grid item xs={4}>
                        <Box className="padding-24px br-16px bg-gray-50">
                            <Box className="flex-row-space-between">
                                <Box>
                                    <Typography className="text-md-semi-bold gray-900">
                                        Virtual
                                    </Typography>
                                </Box>
                            </Box>
                            {isLoading ? <Skeleton height={500} variant='rectangular' width={'100%'}/> :
                                <DonutChart
                                    chartOptions={{ ...VIRTUAL_CHART_OPTIONS, labels: virtualChannel?.labels, counts: virtualChannel?.counts }}
                                    chartSeries={virtualChannel?.chartSeries}
                                />
                            }
                        </Box>
                    </Grid>
                    {/* Peer to Peer Channel Affinity */}
                    <Grid item xs={4}>
                        <Box className="flex-column-space-between padding-24px br-16px bg-gray-50 height-100">
                            <Box className="flex-row-space-between">
                                <Box>
                                    <Typography className="text-md-semi-bold gray-900">
                                        Peer to Peer Channel Affinity
                                    </Typography>
                                </Box>  
                            </Box>
                            {isLoading ? <Skeleton height={500} variant='rectangular' width={'100%'}/> :
                                <SemiDonutChart
                                    chartOptions={{ ...SEMI_DONUT_CHART_OPTIONS, labels: peerToPeerChannel?.labels || [], counts: peerToPeerChannel?.counts || [] }}
                                    chartSeries={peerToPeerChannel?.chartSeries||[]}
                                />
                            }
                        </Box>
                    </Grid>
                    {/* In-Person */}
                    <Grid item xs={4}>
                        <Box className="padding-24px br-16px bg-gray-50">
                            <Box className="flex-row-space-between">
                                <Box>
                                    <Typography className="text-md-semi-bold gray-900">
                                        In-Person
                                    </Typography>
                                </Box>
                            </Box>
                            {isLoading ? <Skeleton height={500} variant='rectangular' width={'100%'}/> :
                                <DonutChart
                                    chartOptions={{ ...IN_PERSON_CHART_OPTIONS, labels: inPersonChannel?.labels, counts: inPersonChannel?.counts }}
                                    chartSeries={inPersonChannel?.chartSeries}
                                />
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
